import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import localPersistence from "redux-persist/lib/storage";
import appState from "./ducks/appStateSlice";
import shop from "./ducks/shopSlice";
import user from "./ducks/userSlice";
import products from "./ducks/productsSlice";
import shoppingCart from "./ducks/shoppingCartSlice";
import checkout from "./ducks/checkoutSlice";
import search from "./ducks/searchSlice";

const checkoutPersistConfig = {
  key: "checkout",
  storage: localPersistence,
  blacklist: ["inLocoLocation", "submitError", "cardCVV"],
};

const cartPersistConfig = {
  key: "shoppingCart",
  storage: localPersistence,
};

const shopPersistConfig = {
  key: "shop",
  storage: localPersistence,
  whitelist: ["user18Older"],
};

const userPersistConfig = {
  key: "user",
  storage: localPersistence,
};

const rootReducer = combineReducers({
  checkout: persistReducer(checkoutPersistConfig, checkout),
  shoppingCart: persistReducer(cartPersistConfig, shoppingCart),
  appState,
  shop: persistReducer(shopPersistConfig, shop),
  user: persistReducer(userPersistConfig, user),
  products,
  search,
});

export const store = configureStore({
  reducer: rootReducer,
  // Na RTK 2 o getDefaultMiddleware deixou de ser export solto: vem como
  // argumento do callback.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export function getState() {
  return store.getState();
}

window.store = store; // for devs! 😉
